import type { StyleOverrides } from '@mui/joy/styles';
import type { IconButtonSlot } from '@mui/joy/IconButton';
import type { Theme } from '@unifyapps/style/joy/theme';
import { getButtonStyleOverrides } from '../Button/style-overrides';

export const getIconButtonStyleOverrides = (): StyleOverrides<IconButtonSlot, unknown, Theme> => {
  return {
    root: getButtonStyleOverrides().root,
  };
};
